import dayjs from "dayjs";
import { LloCasesToFormItem } from "../../../../api";
import {
  DEFAULT_SORT_RULES,
  type SortDirection,
  type SortRule,
  type SortableColumn,
} from "./types";

function getSortValue(row: LloCasesToFormItem, column: SortableColumn): string | number {
  switch (column) {
    case "caseName":
      return row.caseName?.toLowerCase() ?? "";
    case "stage":
      return row.stage?.toLowerCase() ?? "";
    case "raa":
      return row.raa?.toLowerCase() ?? "";
    case "ap":
      return row.ap?.toLowerCase() ?? "";
    case "lloExpiration":
      return row.lloExpiration?.toLowerCase() ?? "";
    case "complaintFiledDate":
      return row.complaintFiledDate ? dayjs(row.complaintFiledDate).valueOf() : 0;
    case "formByDate":
      return row.formByDate ? dayjs(row.formByDate).valueOf() : 0;
    case "daysPastFormBy":
      return row.daysPastFormBy ?? 0;
    default:
      return "";
  }
}

function compareSortValues(
  aValue: string | number,
  bValue: string | number,
  order: SortDirection
) {
  if (aValue < bValue) return order === "asc" ? -1 : 1;
  if (aValue > bValue) return order === "asc" ? 1 : -1;
  return 0;
}

function normalizeSortRules(rules: SortRule[] | undefined): SortRule[] {
  if (!rules?.length) return [...DEFAULT_SORT_RULES];
  const seen = new Set<SortableColumn>();
  const normalized: SortRule[] = [];
  rules.forEach((rule) => {
    if (seen.has(rule.column)) return;
    seen.add(rule.column);
    normalized.push(rule);
  });
  return normalized.length > 0 ? normalized : [...DEFAULT_SORT_RULES];
}

export function sortRows(rows: LloCasesToFormItem[], rules: SortRule[]): LloCasesToFormItem[] {
  const sortRules = normalizeSortRules(rules);
  return [...rows].sort((a, b) => {
    for (const rule of sortRules) {
      const result = compareSortValues(
        getSortValue(a, rule.column),
        getSortValue(b, rule.column),
        rule.direction
      );
      if (result !== 0) return result;
    }
    return 0;
  });
}
